import React from 'react';
import { useDispatch } from 'react-redux';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Checkbox, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { closeModal } from '../../reducers/modal';
import useLocalStorage from '../utility/useLocalStorage';
import InfoContent from '../utility/InfoContent';

const AboutModal = ({ styles }) => {
  const [value, setValue] = useLocalStorage('dontShowModal', 'false');

  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(closeModal());
  };

  const handleCheckboxChange = (checked) => {
    setValue(`${checked}`);
  };

  return (
    <>
      <DialogTitle
        id="responsive-dialog-title"
        style={{
          ...styles.title,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        Welcome to the Massachusetts Broadband Map
        <IconButton
          size="small"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={styles.content}>
        <InfoContent />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Checkbox
            checked={value === 'true'}
            onChange={(e) => handleCheckboxChange(e.target.checked)}
          />
          <p style={{ margin: 0 }}>do not show this again</p>
        </div>
      </DialogContent>
    </>
  );
};

export default AboutModal;
